import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import apiClient from './api-client';
const SCOPE = 'identity-verification-session';
const DETAIL = 'detail';
const keysFactory = {
    detail: (id, financingProgram) => [{ scope: SCOPE, entity: DETAIL, id, financingProgram }],
};
const getIdentityVerificationSession = async ({ queryKey: [{ id, financingProgram }], }) => {
    try {
        const response = await apiClient.get(`/${financingProgram}/creditApplication/${encodeURIComponent(id)}/IdentityVerificationSession`);
        return response.data;
    }
    catch {
        return null;
    }
};
export function useGetIdentityVerificationSession(creditApplicationId, financingProgram) {
    const { isFetching, data } = useQuery({
        queryKey: keysFactory.detail(creditApplicationId, financingProgram),
        queryFn: getIdentityVerificationSession,
        enabled: !!creditApplicationId,
    });
    return [data ?? null, isFetching];
}
export function useResetIdentityVerificationSession(creditApplicationId, financingProgram) {
    const queryClient = useQueryClient();
    return useCallback(() => queryClient.setQueryData(keysFactory.detail(creditApplicationId, financingProgram), null), [creditApplicationId, financingProgram, queryClient]);
}
const updateIdentityVerificationSession = async ({ id, token: sessionToken, applicantType, financingProgram }) => {
    const response = await apiClient.put(`/${financingProgram}/creditapplication/${encodeURIComponent(id)}/IdentityVerificationSession`, {
        id,
        token: sessionToken,
        applicantType,
    });
    return response.data;
};
export function useUpdateIdentityVerificationSession() {
    const queryClient = useQueryClient();
    const { mutateAsync, isPending, reset } = useMutation({
        mutationFn: updateIdentityVerificationSession,
        onSuccess(_data, variables) {
            const creditApplicationId = variables.id;
            if (creditApplicationId) {
                queryClient.setQueryData(keysFactory.detail(creditApplicationId, variables.financingProgram), {
                    id: creditApplicationId,
                    token: variables.token,
                    applicantType: variables.applicantType,
                });
            }
        },
    });
    return [mutateAsync, isPending, reset];
}
